function initAddClass(){
  document.querySelectorAll('.js-add-class').forEach(function (el) {
    var customClass = el.getAttribute('data-class');
    var customClass2 = el.getAttribute('data-class-2');
    var parallaxOffset = el.getAttribute('data-parallax-offset');

    if (customClass)   el.parentElement.classList.add(customClass);
    if (customClass2)  el.parentElement.classList.add(customClass2);
    if (parallaxOffset) el.parentElement.setAttribute('data-offset', parallaxOffset);
  });
}

document.addEventListener('DOMContentLoaded', initAddClass);

if (window.Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', initAddClass);
  document.addEventListener('shopify:block:select', initAddClass);
  document.addEventListener('shopify:block:deselect', initAddClass);
}